import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { AlertsBus } from 'modules/App';
import GuardianIcon from 'svg/guardian.svg';
import messages from '../../../messages';
import { renderHeader, renderInfo, renderCheckSpam } from '../renderers';
import styles from './confirmTermsOfServicesByGuardian.pcss';
import Actions from './Actions';
import ConfirmationStatusModal from './ConfirmationStatusModal';
import useConfirmationStatus from './useConfirmationStatusEffects';
const ConfirmTermsOfServicesByGuardian = ({ onEditGuardianEmail, onConfirmationCompleted, guardianEmail })=>{
    useStyles(styles);
    useConfirmationStatus(onConfirmationCompleted);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            renderHeader(messages.headers.confirmGuardianEmail),
            /*#__PURE__*/ _jsx(AlertsBus, {
                className: "mb-6"
            }),
            /*#__PURE__*/ _jsx(GuardianIcon, {
                className: "mb-6"
            }),
            renderInfo(messages.infos.confirmGuardianEmail, guardianEmail),
            renderCheckSpam(styles.checkSpam),
            /*#__PURE__*/ _jsx(Actions, {
                onEditGuardianEmail: onEditGuardianEmail
            }),
            /*#__PURE__*/ _jsx(ConfirmationStatusModal, {
                email: guardianEmail,
                status: "Pending"
            })
        ]
    });
};
export default ConfirmTermsOfServicesByGuardian;
